import { React, useContext } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import RemoveIcon from 'assets/icons/remove-icon'

import {
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarDivider,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle
} from '../../../assessment/components/ecosystemData/style'
import { ThreatRemoveIconWrapper, ThreatToggleWrapper } from '../style'
import { HabitatContext } from 'providers/HabitatContext'

const getHabitatLevelData = (item, habitatOptions) => {
  if (item.Level3HabitatId) {
    return {
      habitats: habitatOptions.level3Habitats,
      habitatItemId: item.Level3HabitatId
    }
  }

  if (item.Level2HabitatId) {
    return {
      habitats: habitatOptions.level2Habitats,
      habitatItemId: item.Level2HabitatId
    }
  }

  return {
    habitats: habitatOptions.level1Habitats,
    habitatItemId: item.Level1HabitatId
  }
}

const HabitatsContentHeader = ({ isOpen, item, handleOpenRemoveModal, toggleAccordion, disabled }) => {
  const { defaultHabitatsOptions } = useContext(HabitatContext)
  const { habitats, habitatItemId } = getHabitatLevelData(item, defaultHabitatsOptions)

  const name = habitats.find((element) => {
    return element.value === habitatItemId
  })

  return (
    <EcosystemHeaderNavbarWrapper isOpen={isOpen} data-test="habitats">
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle data-test="habitats-name">{name ? name.label : item.name}</EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <ThreatToggleWrapper isActive={isOpen}>
            <FormattedMessage id="expand" />
            {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
          </ThreatToggleWrapper>
          {!disabled && (
            <>
              <EcosystemHeaderNavbarDivider />
              <ThreatRemoveIconWrapper
                delete={true}
                data-test="remove-button"
                onClick={(e) => {
                  e.stopPropagation()
                  handleOpenRemoveModal(item)
                }}
              >
                <RemoveIcon />
              </ThreatRemoveIconWrapper>
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
  )
}

export default HabitatsContentHeader

HabitatsContentHeader.propTypes = {
  isOpen: PropTypes.bool,
  item: PropTypes.shape({
    Level1HabitatId: PropTypes.number,
    Level2HabitatId: PropTypes.number,
    Level3HabitatId: PropTypes.number,
    name: PropTypes.string
  }).isRequired,
  handleOpenRemoveModal: PropTypes.func.isRequired,
  toggleAccordion: PropTypes.func,
  disabled: PropTypes.bool
}